import gql from 'graphql-tag'

export const QUERY_GET_COMERCIALS = gql`
  query Commercials(
    $search: String
    $page: Int
    $pageSize: Int
    $status: [String]
    $sort: [String]
    $sortDirection: [SortDirection]
    $mode: CommercialModes
    $franchise: Boolean
    $only_franchise: Boolean
    $units: [ID]
  ) {
    commercials(
      search: $search
      page: $page
      status: $status
      pageSize: $pageSize
      sort: $sort
      sortDirection: $sortDirection
      mode: $mode
      franchise: $franchise
      only_franchise: $only_franchise
      units: $units
    ) {
      records
      page
      commercials {
        ... on BannerCommercial {
          _id
          title
          description
          scheduled
          status
          priority
          action {
            type
            reference_id
            link
          }
          units {
            name
          }
          type
          initial_date
          final_date
          updated_at
        }
      }
    }
  }
`

export const QUERY_GET_APP_LINKS = gql`
  query AppPagesLinks {
    appPagesLinks {
      title
      link
    }
  }
`

export const QUERY_GET_COMMERCIAL_BY_ID = gql`
  query Commercial($id: ID!, $franchise: Boolean, $only_franchise: Boolean) {
    commercial(_id: $id, franchise: $franchise, only_franchise: $only_franchise) {
      ... on BannerCommercial {
        _id
        title
        description
        status
        priority
        image_url
        type
        link
        action {
          type
          reference_id
          link
        }
        units {
          id_erp
          name
        }
        description
        initial_date
        final_date
      }
    }
  }
`

export const MUTATION_UPSERT_BANNER = gql`
  mutation UpsertBannerCommercial($data: BannerCommercialInput!) {
    upsertBannerCommercial(data: $data) {
      _id
    }
  }
`

export const MUTATION_UPSERT_DRAFT_BANNER = gql`
  mutation UpsertDraftBannerCommercial($data: DraftBannerCommercialInput!) {
    upsertDraftBannerCommercial(data: $data) {
      _id
      message
    }
  }
`

export const MUTATION_DELETE_COMMERCIAL = gql`
  mutation DeleteCommercial($id: ID!) {
    deleteCommercial(_id: $id) {
      _id
      message
    }
  }
`

export const MUTATION_CLONE_COMMERCIAL = gql`
  mutation CloneCommercial($id: ID!) {
    cloneCommercial(_id: $id) {
      _id
      message
    }
  }
`

export const MUTATION_FINALIZE_COMMERCIAL = gql`
  mutation FinalizeCommercial($id: ID!) {
    finalizeCommercial(_id: $id) {
      _id
      message
    }
  }
`

export const MUTATION_UNSCHEDULED_COMMERCIAL = gql`
  mutation UnscheduleCommercial($id: ID!) {
    unscheduleCommercial(_id: $id) {
      _id
      message
    }
  }
`
